<template>
  <div
    class="comp-select-box"
    :class="{ active: open, clickable: options.length > 1 }"
  >
    <div
      class="value current-value"
      v-for="c in formattedOption"
      :key="c.key"
      :class="{ single: options.length === 1 }"
      :title="c.key"
      @click="openDropdown"
    >
      <div class="name">{{ c.key }}</div>
      <img class="chevron" :src="getIcon('triangle.svg')" />
    </div>
    <div class="options" v-if="open && options.length > 1">
      <div
        class="value option-value"
        v-for="c in options"
        :key="c.key"
        :title="c.key"
        @click="change(c)"
      >
        <div class="check" v-if="id === c.id">
          <img :src="getIcon('checkmark-circle.svg')" />
        </div>
        <div class="name">{{ c.key }}</div>
      </div>
    </div>
    <div class="outside" v-if="open" @click="open = false"></div>
  </div>
</template>

<script>
export default {
  name: 'InputSelectBox',
  props: {
    options: {
      required: true,
      type: Array,
      validator: (options) =>
        options.every(
          (option) => 'id' in option && 'key' in option && 'value' in option
        ),
    },
    id: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    formattedOption() {
      return this.options.filter((option) => option.id === this.id);
    },
  },
  methods: {
    openDropdown() {
      if (this.options.length > 1) {
        this.open = !this.open;
      }
    },
    change(c) {
      this.open = false;

      this.$emit('change', c.value);
    },
  },
};
</script>

<style scoped lang="scss">
@import './src/sass/variables';

$c-primary: #196cae;

.comp-select-box {
  position: relative;
  flex-grow: 1;
  background: #fff;
  border: 1px solid #d7dae2 !important;
  user-select: none;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
  min-height: 36px;
  box-sizing: border-box;
  border-radius: 8px;

  &.active {
    border-color: $color-primary !important;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0);
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom: none !important;

    .chevron {
      transform: rotate(90deg) !important;
    }
  }

  .value {
    padding-top: 8px !important;
    padding-bottom: 4px !important;
    display: flex;
    justify-content: space-between;
    position: relative;
    height: 32px;
    box-sizing: border-box;
    transition: background ease 0.3s;
    flex-shrink: 1;
    border-radius: 8px;

    .name {
      font-size: 13px;
      line-height: 17px;
      transition: color ease 0.3s;
      color: #424140;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding-right: 5px;
    }

    .chevron {
      margin-left: auto;
      transform: rotate(-90deg);
      transition: all ease 0.2s;
    }

    .price {
      font-weight: bold;
      font-size: 12px;
      line-height: 17px;
      transition: color ease 0.3s;
    }

    &:nth-child(odd) {
      background: $color-secondary;
    }
  }

  .mobile-select {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    width: 100%;
    z-index: 2;
  }

  .value.current-value {
    background: #ffffff;
    padding-left: 13px !important;
    padding-right: 16px !important;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  .options {
    box-sizing: content-box;
    position: absolute;
    z-index: 31;
    left: -1px;
    min-width: 100%;
    top: 35px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    animation: box-shadow-popup 0.6s;
    border: 1px solid $color-primary !important;
    border-top: none !important;

    @keyframes box-shadow-popup {
      from {
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0);
      }
      to {
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
      }
    }

    .option-value {
      border-radius: 0 !important;
      padding: 0 10px 0 22px !important;
      align-items: center;

      &:hover {
        background: $c-primary;
        color: #ffffff;

        .name,
        .price {
          color: #ffffff;
        }
      }

      .check {
        position: absolute;
        left: 4px;
        top: 9px;
      }
    }
  }

  .outside {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 30;
  }
}
</style>
